export const invoices: TableModule = {
    name: "invoices",
    route: "spa.invoices",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    columns: [
        {
            name: "number",
            mobile: true,
        }, {
            name: "organisation",
            mobile: true,
        }, {
            name: "status",
            mobile: true,
        },
    ],
    filters: [],
    quickFilters: [],
    tools: []
}